package com.ervasstudio.tracoemovimento.pages.home

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.pages.home.mobile.TracoEMovimentoSectionMobile


@Composable
fun TracoEMovimentoSection(isMobile: Boolean) {
    if (isMobile) {
        TracoEMovimentoSectionMobile()
    } else {
        TracoEMovimentoSectionDesktop()
    }
}